<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.userInfo.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('collectionManagement')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('paymentDays')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('bookName')">
                                <el-input v-model="searchform.blurry" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('bookName')"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('addPaymentDays')}}</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="bookName" :label="$t('bookName')"></el-table-column>
                        <el-table-column prop="startNum" :label="$t('startNum')"></el-table-column>
                        <el-table-column prop="endNum" :label="$t('endNum')"></el-table-column>
                        <el-table-column prop="type" label="分配类型">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.type==1" type="primary" size="mini">随机</el-tag>
                                <el-tag v-if="scope.row.type==0" type="warning" size="mini">固定</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="250">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm :title="$t('isDel')" @confirm="deleteproduct(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                                <el-tooltip style="margin-left:5px;" class="item" effect="dark" :content="$t('dc1')" placement="top">
                                    <el-button size="small" @click="daycall(scope.row)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                </el-tooltip>
                                <el-tooltip style="margin-left:5px;" class="item" effect="dark" :content="$t('der2')" placement="top">
                                    <el-button size="small" @click="derate(scope.row)" type="primary" icon="el-icon-remove-outline" circle plain></el-button>
                                </el-tooltip>
                                <el-tooltip style="margin-left:5px;" class="item" effect="dark" :content="$t('der7')" placement="top">
                                    <el-button size="small" @click="estimate(scope.row)" type="primary" icon="el-icon-s-opportunity" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1 ? $t('addPaymentDays') : $t('editPaymentDays')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('bookName')" prop="bookName">
                        <el-input v-model="form.bookName" />
                    </el-form-item>
                    <el-form-item :label="$t('startNum')" prop="startNum">
                        <el-input-number v-model.number="form.startNum" :min="-2"/>
                    </el-form-item>
                    <el-form-item :label="$t('endNum')" prop="endNum">
                        <el-input-number v-model.number="form.endNum" :min="-1"/>
                    </el-form-item>
                    <el-form-item label="分配类型" prop="type">
                        <el-radio-group v-model="form.type">
                            <el-radio :label="1" select>随机</el-radio>
                            <el-radio :label="0">固定</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                options: [{
                    value: 'mx',
                    label: '墨西哥'
                }, {
                    value: 'pe',
                    label: '秘鲁'
                }],
                form: {
                    id: null,
                    bookName: null,
                    startNum: null,
                    endNum: null,
                    nation:null,
                    type:null,
                },
                rules:{
                    bookName:[{ required: true, message: this.$t('pleaseBookName'), trigger: 'blur' },],
                    startNum:[{ required: true, trigger: 'blur' },],
                    //nation:[{ required: true, trigger: 'blur' },],
                    endNum:[{ required: true, trigger: 'blur' },],
                    type:[{ required: true, trigger: 'blur' },],
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                searchform: {
                    blurry: "",
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
            }
        },
        created() {
            this.userInfo=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    bookName: null,
                    startNum: null,
                    type: 1,
                    nation:localStorage.getItem("nation"),
                    endNum: null
                }
            },
            derate(row){
                this.$router.push({path:"/derate",query:{accountId:row.id}})
            },
            daycall(row){
                this.$router.push({path:"/daycall",query:{accountId:row.id,bookName:row.bookName}})
            },
            estimate(row){
                this.$router.push({path:"/estimate",query:{accountId:row.id}})
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.bookName = row.bookName
                this.form.startNum = row.startNum
                this.form.endNum = row.endNum
                this.form.nation = row.nation
                this.form.type = row.type
                this.showadd = true
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList()
            },
            deleteproduct(row) {
                _api.delete(apiurl.accountBook, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                if(this.form.bookName==null || this.form.bookName==""){
                    this.$message.error(this.$t('pleaseBookName'))
                    return
                }
                if(this.form.endNum < this.form.startNum){
                    this.$message.error(this.$t('startLgend'))
                    return
                }
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.accountBook, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            bookName: null,
                            startNum: null,
                            type: null,
                            nation:localStorage.getItem("nation"),
                            endNum: null
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.accountBook, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            bookName: null,
                            startNum: null,
                            type: null,
                            nation:localStorage.getItem("nation"),
                            endNum: null
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList() {
                this.loading = true
                _api.get(apiurl.accountBook, {
                    blurry: this.searchform.blurry,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.blurry=null
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
            
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>